module.exports = __webpack_public_path__ + "assets/AngleMidpoint.d28a6ec8c59a387fe7319586fad50e4f.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/AngleMidpoint.gmt
// module id = 900
// module chunks = 0